export default __webpack_public_path__ + "static/media/heart.d3a113c6.jpg";